import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-badge-list',
  templateUrl: './badge-list.component.html',
  styleUrls: ['./badge-list.component.css']
})
export class BadgeListComponent implements OnInit {
  currentPage = 1;
  totalPages = 0;
  totalItems = 0;
  pageSize = 20;
  loading = false;

  constructor(private dataService: DataService) { }
  columns: any = {
    columnsName: ["id", "numero", "validite", "numeroParc", "inspecteur.nom"],
    field: ["#", "numero", "validite", "Numero Parc", "NomInspecteur"]
  }
  moisOptions = [
    { value: 'UN_MOIS', label: '1 MOIS' },
    { value: 'DEUX_MOIS', label: '2 MOIS' },
    { value: 'TROIS_MOIS', label: '3 MOIS' },
    { value: 'QUATRE_MOIS', label: '4 MOIS' },
    { value: 'CINQ_MOIS', label: '5 MOIS' },
    { value: 'SIX_MOIS', label: '6 MOIS' },
    { value: 'SEPT_MOIS', label: '7 MOIS' },
    { value: 'HUIT_MOIS', label: '8 MOIS' },
    { value: 'NEUF_MOIS', label: '9 MOIS' },
    { value: 'DIX_MOIS', label: '10 MOIS' },
    { value: 'ONZE_MOIS', label: '11 MOIS' },
    { value: 'DOUZE_MOIS', label: '12 MOIS' },
    { value: 'TREIZE_MOIS', label: '13 MOIS' },
    { value: 'QUATORZE_MOIS', label: '14 MOIS' },
    { value: 'QUINZE_MOIS', label: '15 MOIS' },
    { value: 'SEIZE_MOIS', label: '16 MOIS' },
    { value: 'DIX_SEPT_MOIS', label: '17 MOIS' },
    { value: 'DIX_HUIT_MOIS', label: '18 MOIS' },
    { value: 'DIX_NEUF_MOIS', label: '19 MOIS' },
    { value: 'VINGT_MOIS', label: '20 MOIS' }
  ];
  badges: any[] = []

  ngOnInit(): void {
    // Charger la première page au démarrage
    this.loadBadges(0);
  }

  loadBadges(page: number) {
    this.loading = true;

    this.dataService.loadData("Badges", page, this.pageSize).subscribe({
      next: (response: any) => {
        console.log('✅ Badges loaded:', response);

        if (response && response.content) {
          // Mapper les badges avec les labels de validité
          this.badges = response.content.map((badge: any) => {
            const option = this.moisOptions.find(opt => opt.value === badge.validite);
            return {
              ...badge,
              validite: option ? option.label : badge.validite
            };
          });

          // Mettre à jour les informations de pagination
          this.totalPages = response.totalPages || 0;
          this.totalItems = response.totalElements || 0;
          this.currentPage = (response.pageable?.pageNumber || 0) + 1;

          console.log(`📊 Pagination - Page: ${this.currentPage}/${this.totalPages}, Total: ${this.totalItems} items`);
        }

        this.loading = false;
      },
      error: (error) => {
        console.error('❌ Error loading badges:', error);
        this.loading = false;
        this.badges = [];
      }
    });
  }

  onPageChange(page: number) {
    console.log("📄 Page changed to:", page);
    this.loadBadges(page - 1); // Backend utilise des index 0-based
  }
}
